<div class="row">
    <div class="col-lg-12 ">
        <div class="margin-top-10">

            <div class="table-responsive">
                <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
                    <thead>
                        <tr>
                            <th>Analysis Name</th>
                            <th>Number Of Tenants</th>
                            <th>Total Price</th>
                            <th>Total NOI</th>
                            <th>Avg. CAP Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of portfolioAnalysisList;let i = index ">
                            <td><p><a (click)="compare(item.AnalysisId);" >{{item.AnalysisName}}</a></p></td>
                            <td><p>{{item.NoOfProperties}}</p></td>
                            <td><p>{{(item.TotalPrice) ? '$ '+(item.TotalPrice |number:0) : '-'}}</p></td>
                            <td><p>{{(item.TotalNOI) ? '$ '+(item.TotalNOI |number:0) : '-'}}</p></td>
                            <td><p>{{item.AvgCapRate!=null?item.AvgCapRate + '%':'-'}}</p></td>

                        </tr>
                    </tbody>
                    <tfoot>
                        <tr *ngIf="portfolioAnalysisList?.length == 0 ">
                            <td colspan="8" class="odd no-data-available">
                                <div class="nodata">
                                    <i class="fa fa-exclamation-triangle icon"></i>
                                    <p>No Data Available</p>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</div>
